import React, { useRef, useState } from 'react';
import { animated, useSpring } from 'react-spring';
import { useGesture } from 'react-with-gesture';
import './TrackRowActionsWrapper.scss';

const c = 0.55;
const d = 960;
const getRubberBandingInterpolationOutside = (x, left, right) =>
  x &&
  x.interpolate(
    v =>
      v -
      (1.0 -
        1.0 /
          ((Math.max(0, Math.abs(v) - (Math.sign(v) === 1 ? left : right)) *
            c) /
            d +
            1.0)) *
        d *
        Math.sign(v)
  );

export default function LongSwipeToTriggerMainActionShortSwipeToRevealSecondaryIcons({
  children,
  className = '',
  onAddRemove,
  isSaved
}) {
  const leftWrapperWidth = 95;
  const rightWrapperWidth = 95;

  let [expandedDirection, setExpandedDirection] = useState(0);
  // FIXME: `useGesture` and the hook has different lifecycles, and we need to
  // set the updated value in a ref to be able to read it back in the next
  // `useGesture` callback, but then we don't trigger any rerenders, so we do
  // that separately 🤷‍
  let [hackRerenderValue, setHackRerenderValue] = useState(0);
  const primaryActionTriggeredForDirectionRef = useRef(0);
  const [{ x }, setX] = useSpring(() => ({
    x: 0
  }));

  const bind = useGesture({
    passive: {
      passive: false
    },
    onAction: args => {
      const {
        event,
        delta: [deltaX],
        direction: [directionX, directionY],
        velocity,
        down
      } = args;
      const currentDirectionWrapperWidth = expandedDirection
        ? expandedDirection === 1
          ? leftWrapperWidth
          : rightWrapperWidth
        : deltaX > 0 //FIXME:
        ? leftWrapperWidth
        : rightWrapperWidth;

      if (down) {
        if (Math.abs(deltaX) > 10) {
          event.preventDefault();
          event.stopPropagation();
        }
        if (Math.abs(deltaX) >= currentDirectionWrapperWidth) {
          primaryActionTriggeredForDirectionRef.current = Math.sign(deltaX);
          setHackRerenderValue(Date.now());
        } else {
          primaryActionTriggeredForDirectionRef.current = 0;
          setHackRerenderValue(Date.now());
        }
        // } else if (!primaryActionTriggeredForDirectionRef.current) {
        //   expandedDirection =
        //     expandedDirection === 0 &&
        //     ((velocity > 0.5 && Math.abs(directionX) > Math.abs(directionY)) ||
        //       Math.abs(deltaX) >= currentDirectionWrapperWidth / 2)
        //       ? Math.sign(deltaX)
        //       : 0;
        //   setExpandedDirection(expandedDirection);
      } else if (primaryActionTriggeredForDirectionRef.current === -1) {
        onAddRemove();
        // showMessage(
        //   deltaX > 0 ? 'Added to Queue' : 'Added to Liked Songs',
        //   Date.now()
        // );
      }

      const dx = expandedDirection
        ? expandedDirection === 1
          ? currentDirectionWrapperWidth
          : -currentDirectionWrapperWidth
        : 0;

      setX({
        x: global.isScrollingY
          ? 0
          : down
          ? deltaX + dx
          : expandedDirection
          ? dx
          : 0,
        immediate: name => down && name === 'x'
      });
    }
  });

  const x2 = getRubberBandingInterpolationOutside(
    x,
    leftWrapperWidth,
    rightWrapperWidth
  );

  return (
    <animated.div
      {...bind()}
      className={className}
      style={{
        background:
          primaryActionTriggeredForDirectionRef.current === -1 && isSaved
            ? '#cf383c'
            : primaryActionTriggeredForDirectionRef.current
            ? '#3c8143'
            : '#282828'
      }}
    >
      <animated.div
        className="TrackRow__swipe-action TrackRow__swipe-action-left"
        style={{
          transform:
            x2 &&
            x2.interpolate({
              map: Math.abs,
              range: [0, leftWrapperWidth],
              output: [
                `translateX(-${leftWrapperWidth / 2}px)`,
                `translateX(0px)`
              ]
            }),
          opacity: x && x.interpolate(x => (x > 0 ? 1 : 0)),
          background: primaryActionTriggeredForDirectionRef.current
            ? '#3c8143'
            : '#282828'
        }}
        // onClick={() => showMessage('Added to Queue', Date.now())}
      >
        <AddToQueueIcon color="currentColor" />
      </animated.div>

      <animated.div
        className="TrackRow__swipe-action TrackRow__swipe-action-right"
        style={{
          transform:
            x2 &&
            x2.interpolate({
              map: Math.abs,
              range: [0, rightWrapperWidth],
              output: [
                `translateX(${rightWrapperWidth / 2}px)`,
                `translateX(0px)`
              ]
            }),
          opacity: x && x.interpolate(x => (x < 0 ? 1 : 0))
        }}
        onClick={onAddRemove}
      >
        <HeartIcon
          color="currentColor"
          isActive={
            primaryActionTriggeredForDirectionRef.current === -1
              ? !isSaved
              : isSaved
          }
        />
      </animated.div>

      <animated.div
        className="row-contents"
        style={{
          transform: x2 && x2.interpolate(x => `translate3d(${x}px,0,0)`)
        }}
      >
        {children}
      </animated.div>
    </animated.div>
  );
}

const AddToQueueIcon = ({ color = 'white', ...rest }) => (
  <svg
    version="1.1"
    width="32"
    height="32"
    id="add-to-queue-24-layer"
    viewBox="0 0 32 32"
    enableBackground="new 0 0 32 32"
    {...rest}
  >
    <path
      fill="#fff"
      d="M18 11v1h9v-1h-9zM5 30h22v-1H5v1zm0-9h22v-1H5v1zM15 8.5a6.5 6.5 0 10-13 0 6.5 6.5 0 0013 0zM4 9V8h4V4h1v4h4v1H9v4H8V9H4z"
    />
  </svg>
);

const HeartIcon = ({ isActive, color = 'white', ...rest }) => (
  <svg
    version="1.1"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    enableBackground="new 0 0 32 32"
    fill={color}
    {...rest}
  >
    <rect
      transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 24 1.776357e-15)"
      opacity={0}
      fill="none"
      width="24"
      height="24"
    />
    {isActive ? (
      <path
        fill="#fff"
        d="M27.319 5.927a7.445 7.445 0 00-10.02-.462s-.545.469-1.299.469c-.775 0-1.299-.469-1.299-.469a7.445 7.445 0 00-10.02 10.993l9.266 10.848a2.7 2.7 0 004.106 0l9.266-10.848a7.447 7.447 0 000-10.531z"
      />
    ) : (
      <path
        fill="#fff"
        d="M27.672 5.573a7.904 7.904 0 00-10.697-.489c-.004.003-.425.35-.975.35-.564 0-.965-.341-.979-.354a7.904 7.904 0 00-10.693.493A7.896 7.896 0 002 11.192c0 2.123.827 4.118 2.301 5.59l9.266 10.848a3.196 3.196 0 004.866 0l9.239-10.819A7.892 7.892 0 0030 11.192a7.896 7.896 0 00-2.328-5.619zm-.734 10.56l-9.266 10.848c-.837.979-2.508.979-3.346 0L5.035 16.104A6.9 6.9 0 013 11.192 6.9 6.9 0 015.035 6.28a6.935 6.935 0 014.913-2.048 6.89 6.89 0 014.419 1.605A2.58 2.58 0 0016 6.434c.914 0 1.555-.53 1.619-.585a6.908 6.908 0 019.346.431A6.904 6.904 0 0129 11.192c0 1.855-.723 3.6-2.062 4.941z"
      />
    )}
  </svg>
);
